import { getDuration } from '@domains/orchestrator-pricing-committee/utils/dates';

export const DateDuration = ({
  startAt,
  endAt,
}: {
  startAt?: string;
  endAt?: string;
}) => {
  const duration = getDuration(startAt ?? '', endAt ?? '');

  return (
    <div>
      <div className="fw-bold">Tiempo total</div>
      {
        <div>
          {duration.days}d {duration.hours}h {duration.minutes}m{' '}
          {duration.seconds}s
        </div>
      }
    </div>
  );
};
